import { themeVars } from '@customerio/pluma-components/css/theme-tokens';
import { Box } from '@customerio/pluma-components/react';
import type { ComponentProps } from 'react';
import * as styles from './index.css';
import { assignInlineVars } from '@vanilla-extract/dynamic';

export function GradientRing({
  children,
  className,
  radius = 6,
  style,
  ...rest
}: ComponentProps<typeof Box> & { radius?: keyof typeof themeVars.radius }) {
  return (
    <Box
      {...rest}
      className={[styles.gradientContainer, className]}
      style={[style, assignInlineVars({ [styles.ringRadius]: themeVars.radius[radius] })]}
    >
      <div className={styles.gradientRing} />
      {children}
    </Box>
  );
}

export { gradientBackground } from './index.css';
